import Sorting from "./sorting";

export class Leaderboard {
    id!: string;
    name!: string;
    sorting!: Sorting;
    secret!: string;
}
